module.exports = __webpack_public_path__ + "static/media/11D.5961fb77.jpg";